import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useGetCannyIoBoards } from 'shared/data/webApp/v1';
import { getPath, Path } from 'urlBuilder';

export const useBoardNavItems = () => {
    const { data, isInitialLoading } = useGetCannyIoBoards();

    const items = useMemo(
        () =>
            (data?.boards || [])
                .filter(({ isPrivate }) => !isPrivate)
                .map(({ id, name, postCount }) => ({
                    value: id,
                    label: name,
                    postCount,
                    as: Link,
                    to: getPath(Path.customerFeedbackBoard, id),
                    wrap: false,
                })),
        [data?.boards]
    );

    return {
        items,
        isInitialLoading,
    };
};
